<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a href=/documents/contracts>Список договоров</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать дополнительное соглашение</li>
        </ol>
    </nav>

    <form class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Клиент</div>
            <select @change="onChangeClient($event)"
                    v-model="forms.client.selected"
                    class="form-select">
                <option v-for="(item, key) in forms.client.items" v-bind:value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Организация</div>
            <select :disabled="!forms.client.selected"
                    @change="onChangeOrg($event)"
                    v-model="forms.organization.selected"
                    class="form-select">
                <option v-for="organization in forms.organization.items"
                        v-bind:value="organization.id">
                    {{ organization.name }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Договор</div>
            <select v-if="forms.contracts.selected"
                    v-model="forms.contracts.selected.contract_id"
                    class="form-select">
                <option v-for="contract in forms.contracts.items"
                        v-bind:value="contract.contract_id">
                    {{ contract.contract_name }} № {{ contract.contract_number }}
                </option>
            </select>
        </div>

        <div class="mb-4">
            <div class="form-label">Название</div>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.name"
                placeholder="Введите название дополнительного соглашения"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Номер</div>
            <input
                type="text"
                class="form-control mb-3"
                v-model="forms.data.number"
                placeholder="Введите номер дополнительного соглашения"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Дата начала действие</div>
            <!--                <VueDatePicker v-model="forms.data.date" locale="ru" :action-row="{ showSelect: false, showCancel: false }"-->
            <!--                               :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"-->
            <!--                               :format="dateFormat" :teleport="true">-->
            <!--                    <template #input-icon>-->
            <!--                        <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"-->
            <!--                             xmlns="http://www.w3.org/2000/svg">-->
            <!--                            <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round" d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />-->
            <!--                        </svg>-->
            <!--                    </template>-->
            <!--                </VueDatePicker>-->
            <input
                type="date"
                class="form-control mb-3"
                v-model="forms.data.date"
                placeholder="Введите дату начала действия дополнительного соглашения"
            >
        </div>

        <div class="mb-4">
            <div class="form-label">Файл</div>
            <a v-bind:href="this.domain + 'documents/' + forms.data.file" target="blank">{{ forms.data.name }}</a>
        </div>

        <div class="mb-4">
            <div class="form-label">Заменить файл</div>
            <input
                accept="application/pdf"
                ref="contractFile"
                @change="onChangeFile($event)"
                type="file"
                class="form-control mb-3"
            >
        </div>
    </form>

    <div class="col-md-4">
        <div class="d-flex w-50 align-items-center justify-content-start">
            <button @click="create" class="btn btn-lg btn-primary me-3">Сохранить</button>
            <a href="/documents/contracts" class="btn btn-lg btn-outline-dark">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>

import { dateFormat } from '../../../../utilites';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContractAdditionalEditComponent",
    components: { Alert },
    props: {
        item_id: {
            type: [Number, String],
            default: 0
        },
        domain: {
            type: [String],
        }
    },
    data: function () {
        return {
            forms: {
                client: {
                    selected: null,
                    items: []
                },
                organization: {
                    selected: null,
                    items: []
                },
                data: {
                    name: null,
                    date: null,
                    number: null,
                    file: null,
                },
                file: {
                    selected: null
                },
                searchingContracts: {
                    openDropDown: false,
                    items: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMounth: null
                },
                contracts: {
                    selected: null,
                    items: []
                }
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        dateFormat,
        getItem: async function () {
            let resp = await axios.get('/documents/contracts/additional/get', {params: {
                    id: this.item_id,
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить дополнительное соглашение к договору, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.client.selected = resp.data.item.client_id;
                this.forms.organization.selected = resp.data.item.organization_id;
                this.forms.data.name = resp.data.item.name;
                this.forms.data.number = resp.data.item.number;
                this.forms.data.date = resp.data.item.date;
                this.forms.data.file = resp.data.item.path;

                this.forms.contracts.selected = {
                    contract_id: resp.data.item.contract_id,
                    contract_name: resp.data.item.contract_name,
                    contract_number: resp.data.item.contract_number,
                };

                this.listOrgs();
                this.listContracts();
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        listClients: async function () {
            let resp = await axios.get('/organizational/client/list', {params: {
                    page: 1,
                    limit: 100
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список клиентов, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.client.items = resp.data.items;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        listOrgs: async function () {
            let resp = await axios.get('/organizational/organizations/list', {params: {
                    page: 1,
                    limit: 100,
                    client_id: this.forms.client.selected
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.forms.organization.items = resp.data.items;
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
        onChangeClient: async function (e) {
            this.forms.client.selected = e.target.value;
            this.listOrgs();
        },
        onChangeOrg: function (e) {
            this.forms.organization.selected = e.target.value;
            this.listContracts();
        },
        onChangeFile: function (e) {
            if (!e.target.files[0] || e.target.files[0].type !== 'application/pdf') {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Только файлы с расширением pdf' });
                e.target.value = null;
            }

            if (e.target.files[0] && e.target.files[0].type === 'application/pdf') {
                this.forms.file.selected = e.target.files[0];
            }
        },
        listContracts: async function () {
            const response = await axios.get('/documents/contracts/list', {params: {
                    page: 1,
                    limit: 100
                }}).catch(res => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список договоров, что-то пошло не так' });
            });

            if (response.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
            }

            if (response.data.status === 'ok') {
                this.forms.contracts.items = response.data.items;
            }
        },
        create: async function() {
            if (!this.forms.client.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента' });
                return;
            }

            if (!this.forms.organization.selected) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите организацию' });
                return;
            }

            if (!this.forms.data.name) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите название документа' });
                return;
            }

            if (!this.forms.data.number) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите номер документа' });
                return;
            }

            if (!this.forms.data.date) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите дату документа' });
                return;
            }

            if (!this.forms.contracts.selected.contract_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите договор' });
                return;
            }

            const formData = new FormData();

            formData.append('id', this.item_id);
            formData.append('client_id', this.forms.client.selected);
            formData.append('org_id', this.forms.organization.selected);
            formData.append('contract_id', this.forms.contracts.selected.contract_id);
            formData.append('name', this.forms.data.name);
            formData.append('number', this.forms.data.number);
            formData.append('date', this.forms.data.date);

            if (this.forms.file.selected) {
                formData.append('file', this.forms.file.selected);
            }

            const resp = await axios.post('/documents/contracts/edit/contract-additional', formData).catch(res => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось отредактировать дополнительное соглашение, что-то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Дополнительное соглашение успешно отредактировано' });
                window.location.reload();
            }

            if (resp.data.status !== 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }
        },
    },
    mounted() {
        this.getItem();
        this.listClients();
    }
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
}

.app-dropdown .disable {
    background-color: #ddd;
    cursor: initial;
}
</style>
